import type { HTMLAttributes, JSX } from "react";
import { cn } from "@repo/cn";

type FlowHelpButtonProps = HTMLAttributes<HTMLButtonElement>;

interface FlowHelpButtonIconProps extends HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

interface FlowHelpButtonLabelProps extends HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

const Icon = ({
  children,
  className,
  ...props
}: FlowHelpButtonIconProps): JSX.Element => (
  <span className={cn("flex items-center", className)} aria-hidden="true" {...props}>
    {children}
  </span>
);

const Label = ({
  children,
  className,
  ...props
}: FlowHelpButtonLabelProps): JSX.Element => (
  <span className={cn("text-sm font-medium", className)} {...props}>
    {children}
  </span>
);

export const FlowHelpButton = ({
  children,
  className,
  ...props
}: FlowHelpButtonProps): JSX.Element => (
  <button
    type="button"
    className={cn(
      "flex items-center gap-1.5 bg-neutral-100 rounded-full px-4 py-2 text-neutral-700",
      className,
    )}
    {...props}
  >
    {children}
  </button>
);

FlowHelpButton.Icon = Icon;
FlowHelpButton.Label = Label;
